import { HttpErrorResponse } from '@angular/common/http';
import { Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DatoEntity, FiltrosFormatoAsistencialEntity, FormatoAsistencialDataEntity, FormatoAsistencialEntity, NodoEntity, NotaEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { FilaComponent } from '../componentes/fila/fila.component';

@Component({
  selector: 'app-cuerpo-pregunta-asistencial',
  templateUrl: './cuerpo-pregunta-asistencial.component.html',
  styleUrls: ['./cuerpo-pregunta-asistencial.component.css']
})
export class CuerpoPreguntaAsistencialComponent implements OnInit {

  @Input() public data: FormatoAsistencialEntity;
  @Input() public filtros: FiltrosFormatoAsistencialEntity;
  @ViewChild('mainContainer' , {read : ViewContainerRef}) container: ViewContainerRef;

  constructor(private servicioFormato: ServicioFormatoAsistencialService,
              private componentFactory: ComponentFactoryResolver) { }

  notas: NotaEntity[] = [];

  ngOnInit() {
    this.getNodos();
  }

  async getNodos() {
    try {
      const response = await this.servicioFormato.getDataFormatoAsistencial(this.filtros.codigoBaseDatos, this.filtros.tta);
      response.subscribe((data: FormatoAsistencialDataEntity) => {
        this.servicioFormato.valoresPregunta = data.valores;
        this.servicioFormato.nodosCompletos = data.nodos;
        this.servicioFormato.datosCompletos = data.datos;
        this.getNodo(data.nodos, data.datos);
      }, (err: HttpErrorResponse) => {
        console.error('Error getNodos()', err);
      });
    } catch (e) {
      console.error('Catch getNodos()');
    }
  }

  async getNodo(nodos: NodoEntity[], data: DatoEntity[]) {
    const nodo = nodos.find((n: NodoEntity) => n.id === this.filtros.pregunta);
    if (nodo ) {
      nodo.datos = this.getData(nodo, data);
      nodo.notas = this.getNotasNodo(nodo);
      nodo.hijos = this.getNodosHijos(nodo, nodos, data, true);
      this.buildFormato(nodo);
    }
  }

  getNodosHijos(nodo: NodoEntity, nodos: NodoEntity[], data: DatoEntity[], search: boolean) {
    return nodos.filter((n: NodoEntity) => {
      n.notas = this.getNotasNodo(n);
      const value = n.padreNodo === nodo.id;
      const tipoObjeto = n.codigoTipoObjeto;
      if (value) { n.datos = this.getData(n, data); }
      if (tipoObjeto && search) { n.hijos = this.getNodosHijos(n, nodos, data, false); }
      return value;
    });
  }

  getData(nodo: NodoEntity, data: DatoEntity[]): DatoEntity[] {
    if (data && data.length > 0) {
      return data.filter((d: DatoEntity) => d.idNodoPrincipal === nodo.id);
    } else {
      return [];
    }
  }

  getNotasNodo(nodo: NodoEntity): NotaEntity[] {
    if (this.notas && this.notas.length > 0) {
      return this.notas.filter((nota: NotaEntity) => {
        return nota.idNodo === nodo.id;
      });
    }
    return [];
  }

  // Construir
  buildFormato(nodo: NodoEntity) {
    const row: ComponentRef<FilaComponent> = this.getRow(nodo);
  }

  getRow(nodo: NodoEntity): ComponentRef<FilaComponent> {
    const factory: ComponentFactory<FilaComponent> = this.componentFactory.resolveComponentFactory(FilaComponent);
    const component: ComponentRef<FilaComponent> = this.container.createComponent(factory);
    component.instance.filtros = this.filtros;
    component.instance.data = this.data;
    component.instance.index = 0;
    component.instance.nodos.push(nodo);
    return component;
  }

}
